export default {
  tooltip: {
    trigger: "item",
    formatter: "{b}: {c} ({d}%)",
  },
  color: ["#6effff", "#374ab0"],
  series: [
    {
      name: "化学供应商",
      type: "pie",
      radius: ["60%", "70%"],
      avoidLabelOverlap: false,
      label: {
        show: true,
        position: "center",
        fontSize: 24,
        formatter: "{d}%\n{b}",
      },
      startAngle: 0,
      emphasis: {
        itemStyle: {},
        label: {
          show: true,
          fontSize: 24,
          fontWeight: "bold",
        },
      },
      labelLine: {
        show: false,
      },
      data: [
        { value: 3240, name: "上海", label: { show: true } },
        { value: 8303, name: "其他", label: { show: false } },
      ],
    },
  ],
};
